import { Suspense } from "react";
import { Layout } from "@/modules/layout/layout";
import { PageSkeleton } from "@/components/skeletons/PageSkeleton";
import { ProtectedAuthRoute } from "@/lib/protected-auth-route";
import { RouteComponentProps } from "wouter";

interface PrivateAuthLayoutRouteProps {
  path: string;
  component: React.ComponentType<RouteComponentProps>;
  title: string;
}

export function PrivateAuthLayoutRoute({
  component: Component,
  title,
  path,
}: PrivateAuthLayoutRouteProps) {
  return (
    <ProtectedAuthRoute
      path={path}
      component={(props) => (
        <Layout title={title}>
          <Suspense fallback={<PageSkeleton />}>
            <Component {...props} />
          </Suspense>
        </Layout>
      )}
    />
  );
}